/**
 * Thumbnail list for upload-model mask results; Save as Object + Cancel at bottom.
 */
const ImageSelectionPanel = ({
  imageSelectionPanelCollapsed,
  setImageSelectionPanelCollapsed,
  visible = false,
  items = [],
  selectedRoomObjectId = null,
  onSelect,
  onCancel,
  onSaveAsObject,
  saveAsObjectLoading = false,
}) => {
  if (!visible) return null;

  return (
    <div className="flex shrink-0 min-h-0 items-stretch">
      <button
        type="button"
        onClick={() => setImageSelectionPanelCollapsed((v) => !v)}
        className="flex w-6 h-12 shrink-0 flex-col items-center justify-center self-center rounded-l-lg transition-colors bg-white/35 box-border backdrop-blur-xl backdrop-saturate-150 border-r border-gray-200/60"
        title={imageSelectionPanelCollapsed ? 'Show image selection panel' : 'Hide image selection panel'}
        aria-expanded={!imageSelectionPanelCollapsed}
        aria-label={
          imageSelectionPanelCollapsed ? 'Show image selection panel' : 'Hide image selection panel'
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`shrink-0 transition-transform duration-300 ease-out ${imageSelectionPanelCollapsed ? '' : 'rotate-180'}`}
          aria-hidden
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <aside
        className={`shrink-0 min-h-0 overflow-hidden transition-[width] duration-300 ease-in-out motion-reduce:transition-none ${
          imageSelectionPanelCollapsed ? 'w-0 pointer-events-none' : 'w-[16rem]'
        }`}
        aria-label="Image Selection"
      >
        <div className="flex h-full min-h-0 w-[16] min-w-[16rem] flex-col gap-4 border-l border-gray-200 border-white/50 bg-white/35 py-4 px-2 box-border backdrop-blur-xl backdrop-saturate-150">
          <div className="flex shrink-0 items-center justify-between gap-2">
            <h3 className="text-sm lao-mn text-gray-700">Image Selection</h3>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto">
            <div className="flex flex-col gap-2">
              {items.map((item, index) => {
                const roomObjectId = Number(item?.roomObjectId);
                const key = Number.isFinite(roomObjectId)
                  ? `room-object-${roomObjectId}`
                  : `item-${index}`;
                const isSelected =
                  Number.isFinite(roomObjectId) && Number(selectedRoomObjectId) === roomObjectId;
                return (
                  <button
                    key={key}
                    type="button"
                    onClick={() => onSelect?.(item)}
                    className={`w-full rounded-md border p-1 text-left transition-colors ${
                      isSelected
                        ? 'border-primary-300 bg-primary-500/30'
                        : 'border-gray-200 bg-white hover:border-primary-200'
                    }`}
                  >
                    <div className="relative w-full overflow-hidden rounded bg-gray-100">
                      <img
                        src={item?.imageUrl || ''}
                        alt={`Mask result ${index + 1}`}
                        className="h-auto w-full object-contain"
                      />
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
          <div className="mt-auto flex shrink-0 gap-2">
            <button
              type="button"
              onClick={() => void onSaveAsObject?.()}
              disabled={saveAsObjectLoading}
              className="flex min-w-0 flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-3 py-2 text-xs font-medium text-primary-300 transition-colors hover:border-primary-300 hover:bg-primary-500 hover:text-primary-300 disabled:cursor-not-allowed disabled:opacity-50"
              title="Save selected polygon as object"
              aria-label="Save as object"
            >
              {saveAsObjectLoading ? 'Saving…' : 'Save as Object'}
            </button>
            <button
              type="button"
              onClick={() => void onCancel?.()}
              className="flex min-w-0 flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-3 py-2 text-xs font-medium text-primary-300 transition-colors hover:border-primary-300 hover:bg-primary-500 hover:text-primary-300"
              title="Cancel image selection"
              aria-label="Cancel"
            >
              Close
            </button>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default ImageSelectionPanel;
